<div class="shell">
  <aside class="sidebar" [class.is-collapsed]="collapsed()">
    <div class="brand">
      <div class="brand-id">
        <div class="brand-mark">PTP</div>
        <div class="brand-text">
          <div class="brand-name">PTP Fleet</div>
          <div class="brand-sub">FLEET COMMAND</div>
        </div>
      </div>

      <button
        class="collapse-btn"
        nz-tooltip
        [nzTooltipTitle]="collapseLabel()"
        nzTooltipPlacement="right"
        [attr.aria-expanded]="!collapsed()"
        [attr.aria-label]="collapseLabel()"
        (click)="toggleCollapsed()"
      >
        <nz-icon [nzType]="collapsed() ? 'menu-unfold' : 'menu-fold'" />
      </button>
    </div>

    <nav class="nav">
      @for (section of sections; track section.label) {
        @if (sectionVisible(section)) {
          <div class="nav-section">
            <div class="nav-label">{{ section.label }}</div>
            @for (item of section.items; track item.label) {
              @if (canSee(item)) {
                @if (item.soon) {
                  <span
                    class="nav-item is-soon"
                    aria-disabled="true"
                    nz-tooltip
                    [nzTooltipTitle]="collapsed() ? item.label + ' — soon' : null"
                    nzTooltipPlacement="right"
                    [attr.aria-label]="collapsed() ? item.label + ' — soon' : null"
                  >
                    <nz-icon [nzType]="item.icon" class="ico" />
                    <span>{{ item.label }}</span>
                    <span class="soon">SOON</span>
                  </span>
                } @else {
                  <a
                    class="nav-item"
                    [routerLink]="item.path"
                    routerLinkActive="is-active"
                    nz-tooltip
                    [nzTooltipTitle]="collapsed() ? item.label : null"
                    nzTooltipPlacement="right"
                    [attr.aria-label]="collapsed() ? item.label : null"
                  >
                    <nz-icon [nzType]="item.icon" class="ico" />
                    <span>{{ item.label }}</span>
                  </a>
                }
              }
            }
          </div>
        }
      }
    </nav>
  </aside>

  <div class="main">
    <header class="topbar">
      <div class="topbar-text">
        <h1>{{ pageTitle() }}</h1>
        <div class="context">Pelabuhan Tanjung Pelepas</div>
      </div>

      <div class="spacer"></div>

      <button
        class="icon-btn"
        nz-tooltip
        [nzTooltipTitle]="theme.switchLabel()"
        [attr.aria-label]="theme.switchLabel()"
        (click)="theme.toggle()"
      >
        <nz-icon [nzType]="theme.mode() === 'dark' ? 'moon' : 'sun'" />
      </button>

      <button
        class="icon-btn"
        nz-dropdown
        [nzDropdownMenu]="notificationMenu"
        [nzVisible]="notifOpen()"
        nzTrigger="click"
        nzPlacement="bottomRight"
        (nzVisibleChange)="onNotifVisibleChange($event)"
        nz-tooltip
        nzTooltipTitle="Notifications"
        aria-label="Notifications"
        aria-haspopup="menu"
      >
        <nz-badge
          class="notif-badge"
          nzSize="small"
          [nzCount]="unreadCount()"
          [nzOverflowCount]="9"
          [nzOffset]="[6, -6]"
        >
          <nz-icon nzType="bell" />
        </nz-badge>
      </button>

      <nz-dropdown-menu #notificationMenu="nzDropdownMenu">
        <app-notification-panel
          [isOpen]="notifOpen()"
          (unreadChanged)="refreshUnreadCount()"
          (closed)="notifOpen.set(false)"
        />
      </nz-dropdown-menu>

      <button
        class="avatar-btn"
        nz-dropdown
        [nzDropdownMenu]="accountMenu"
        nzTrigger="click"
        nzPlacement="bottomRight"
        aria-label="Account menu"
        aria-haspopup="menu"
      >
        @if (user()?.avatarUrl) {
          <nz-avatar
            class="avatar"
            [nzSrc]="user()?.avatarUrl"
            data-testid="header-profile-avatar"
          ></nz-avatar>
        } @else {
          <nz-avatar
            class="avatar"
            [nzText]="getInitialName()"
            data-testid="header-profile-avatar"
          ></nz-avatar>
        }
        <nz-icon nzType="down" class="avatar-caret" />
      </button>

      <nz-dropdown-menu #accountMenu="nzDropdownMenu">
        <ul nz-menu class="account-menu">
          <li class="account-head">
            <span class="account-name">{{ fullName() }}</span>
            <span class="account-mail">{{ user()?.email }}</span>
          </li>
          <li nz-menu-divider></li>
          <li nz-menu-item routerLink="/profile">
            <nz-icon nzType="user" class="mi-ico" />
            <span>Profile</span>
          </li>
          <li nz-menu-item tabindex="0" (click)="logout()" (keydown.enter)="logout()">
            <nz-icon nzType="logout" class="mi-ico" />
            <span>Log out</span>
          </li>
        </ul>
      </nz-dropdown-menu>
    </header>

    <main class="content">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
